export const updateLogs = [
  { id: "up-01", episode: 18, title: "第18集《新的开始》已上线", date: "2026-10-23", tag: "最新", summary: "老宅门口挂起了新的灯笼，秀雅把“家”字贴在门上，这个家终于真正完整了。" },
  { id: "up-02", episode: 17, title: "第17集《雨夜的告白》已上线", date: "2026-10-21", tag: "热播", summary: "雨又下了起来，这一次承宇没有再沉默，他把藏在心里很久的话说了出来。" },
  { id: "up-03", episode: 16, title: "第16集《餐桌上的和解》已上线", date: "2026-10-16", tag: "口碑", summary: "一桌热气腾腾的饭菜前，兄妹俩终于说出了埋藏多年的话，外婆笑着红了眼睛。" },
  { id: "up-04", episode: 15, title: "第15集《真相的碎片》已上线", date: "2026-10-14", tag: "", summary: "尘封的往事一块块拼凑完整，承宇第一次为当年的误解向秀雅道歉。" },
  { id: "up-05", episode: 14, title: "第14集《姐姐的托付》已上线", date: "2026-10-09", tag: "", summary: "母亲转交的旧信揭开了姐姐最后的嘱托，秀雅终于明白自己为何而来。" },
  { id: "up-06", episode: 13, title: "第13集《巷口的流言》已上线", date: "2026-10-07", tag: "", summary: "流言越传越凶，秀雅选择亲自登门，用一份点心化解了邻里多年的误会。" },
  { id: "up-07", episode: 12, title: "第12集《深夜的急诊》已上线", date: "2026-10-02", tag: "", summary: "外婆深夜突发不适，凌晨的长椅上，两人的心第一次靠得那么近。" },
  { id: "up-08", episode: 11, title: "第11集《离开的念头》已上线", date: "2026-09-30", tag: "", summary: "收拾好的行李又一次被放了回去，门口传来外婆唤她名字的声音。" },
  { id: "up-09", episode: 10, title: "第10集《旧照片风波》已上线", date: "2026-09-25", tag: "", summary: "一张被翻出的合影掀起波澜，秀雅第一次感到无力。" },
  { id: "up-10", episode: 9, title: "第9集《生日蛋糕》已上线", date: "2026-09-23", tag: "", summary: "烛光里孩子许下的愿望，让在场的每个人都湿了眼眶。" },
];

export const broadcastSchedule = [
  { weekday: "周三", date: "2026-10-28", episodes: "第19 - 20集", time: "20:00", status: "已排播" },
  { weekday: "周五", date: "2026-10-30", episodes: "第21 - 22集", time: "20:00", status: "已排播" },
  { weekday: "周三", date: "2026-11-04", episodes: "第23集", time: "20:00", status: "预告" },
  { weekday: "周五", date: "2026-11-06", episodes: "第24集（大结局）", time: "20:00", status: "预告" },
];

export const announcements = [
  { id: "an-01", title: "大结局即将于11月6日上线", date: "2026-10-24", content: "陪伴大家走过整个秋天的《善良的小姨子》将于 11 月 6 日迎来最终章，感谢每一位追剧的观众。" },
  { id: "an-02", title: "本周更新安排调整通知", date: "2026-10-20", content: "因排播调整，本周更新时间为周三、周五 20:00，请各位观众留意更新时间。" },
  { id: "an-03", title: "高清资源画质升级说明", date: "2026-10-15", content: "全站剧集画质已升级至高清，带来更细腻清晰的观看体验。" },
];

export default updateLogs;